import { IconArchive } from "@tabler/icons-react";

export default function EmptyStateBox({ message }) {
  return (
    <div className="flex items-center justify-center gap-4 p-6 rounded-xl shadow-md bg-white">
      <IconArchive size={65} className="text-gray-600" />
      <span className="text-lg font-medium text-gray-700">{message}</span>
         
    </div>
  );
}
